// extracted by mini-css-extract-plugin
export default {"titleBox":"gV7TEZZ5ZpoLz2OymOU6"};